import type { ReactNode } from "react";
import { create } from "zustand/react";

import type { ModalBehaviorOptions, ModalCloseOutcome } from "./modal-behavior";

interface RouteModalsState {
  isMounted: boolean;
  fallbackPath: string;
  children: ReactNode;
  behaviorOptions: ModalBehaviorOptions | undefined;
  state: unknown;

  setMounted: (mounted: boolean) => void;
  setFallbackPath: (path: string) => void;
  setChildren: (children: ReactNode) => void;
  setBehaviorOptions: (behaviorOptions: ModalBehaviorOptions) => void;

  peekState: () => unknown;
  setState: (state: unknown) => void;
  clearState: () => void;

  triggerCloseCallback: () => ModalCloseOutcome | void;
  getShouldConfirmClose: () => boolean | undefined;
}

export const useRouteModalsStore = create<RouteModalsState>((set, get) => ({
  isMounted: false,
  fallbackPath: "/",
  children: undefined,
  behaviorOptions: undefined,
  state: null,

  setMounted: (mounted: boolean) =>
    set((state) => ({
      isMounted: mounted,
      behaviorOptions: mounted ? state.behaviorOptions : undefined,
    })),
  setFallbackPath: (path) =>
    set(() => ({
      fallbackPath: path,
    })),
  setChildren: (children) =>
    set(() => ({
      children,
    })),
  setBehaviorOptions: (behaviorOptions) => set({ behaviorOptions }),

  peekState: () => get().state,
  setState: (state: unknown) => set({ state }),
  clearState: () => set({ state: undefined }),

  triggerCloseCallback: () => {
    return get().behaviorOptions?.onClose?.();
  },
  getShouldConfirmClose: () => {
    return get().behaviorOptions?.requireCloseConfirmation;
  },
}));
